import { Settings as LayoutSettings } from '@ant-design/pro-layout';

const Settings: LayoutSettings & {
  pwa?: boolean;
  logo?: string;
} = {
  navTheme: 'light',
  // 拂晓蓝
  primaryColor: '#1890ff',
  layout: 'side',
  contentWidth: 'Fluid',
  fixedHeader: true,
  fixSiderbar: true,
  colorWeak: false,
  title: '健康管理平台',
  pwa: false,
  // logo: '/logo.jpg',
  iconfontUrl: '',
  splitMenus: false,
  headerHeight: 79,
};

export default Settings;
